module.exports = __webpack_public_path__ + "img/step4.bc4b2505.svg";